import { handleRangeDate2SingleDateRangeTimeFilterExtend } from '@intelligence/utils/dateUtils';
import {
  // 日期筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  // 发布时间筛选器
  RELEASE_TIME as RELEASE_TIME_SELECT_FILTER,
  // 级联国家筛选器
  REGION as REGION_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

export const getInitialFormValue = (isOperate: boolean, filterExtend: any, defaultFormValue: any) => {
  // 没有操作过筛选器，不继承
  if (!isOperate) return defaultFormValue ?? {};

  const filterExtendTmp = handleRangeDate2SingleDateRangeTimeFilterExtend(filterExtend);

  /** 各个筛选器的继承值 **/
  const rangeTimeFilterExtend = filterExtendTmp?.[RANGE_TIME_SELECT_FILTER];
  const regionFilterExtend = filterExtendTmp?.[REGION_SELECT_FILTER];
  /** 各个筛选器的继承值 **/

  /** 各个筛选器的默认值 **/
  const rangeTimeDefault = defaultFormValue?.[RANGE_TIME_SELECT_FILTER];
  const releaseTimeDefault = defaultFormValue?.[RELEASE_TIME_SELECT_FILTER];
  const regionDefault = defaultFormValue?.[REGION_SELECT_FILTER];
  /** 各个筛选器的默认值 **/

  return {
    // 日期筛选器
    [RANGE_TIME_SELECT_FILTER]: {
      type: rangeTimeFilterExtend?.filterType ?? rangeTimeDefault?.type,
      value: rangeTimeFilterExtend?.filterValue ?? rangeTimeDefault?.value,
    },
    // 发布时间筛选器始终为 Day 范围，不继承榜单日期的粒度。
    [RELEASE_TIME_SELECT_FILTER]: {
      value: releaseTimeDefault?.value,
    },
    // 级联国家筛选器
    [REGION_SELECT_FILTER]: {
      type: regionFilterExtend?.filterType ?? regionDefault?.type,
      regions: regionFilterExtend?.filterRegions ?? regionDefault?.regions,
      markets: regionFilterExtend?.filterMarkets ?? regionDefault?.markets,
    },
  };
};
